import React from 'react';
import 'twin.macro';

interface TableOfContentsProps {
  items: {
    title: string;
    id: string;
  }[];
}

const TableOfContents: React.FC<TableOfContentsProps> = ({ items }) => (
  <nav tw="flex flex-wrap -mx-3 my-6" aria-label="Table of Contents">
    {items.map((item) => (
      <a
        key={item.id}
        href={`#${item.id}`}
        tw="m-3 rounded bg-blue text-white font-bold text-lg py-3 px-4 transition-colors duration-100 ease-in hover:(bg-blue-700) focus:(outline-none ring ring-blue ring-opacity-70)"
      >
        {item.title}
      </a>
    ))}
  </nav>
);

export default TableOfContents;
